import React from "react";
import { RouteErrorBoundary } from "src/components/ErrorBoundary/RouteErrorBoundary.tsx";
import { ResourceRoute } from "src/framework/ResourceRoute.tsx";
import { queryClient } from "src/lib/react-query.tsx";
import { resourceFormConfigQuery } from "src/system/resourceFormConfigQuery.ts";
import { formTranslationsQuery } from "src/system/formTranslationsQuery.ts";
import { useResourceFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";
import { ResourceFormLayout } from "src/components/Form/ResourceFormLayout.tsx";
import { FormAction } from "src/components/Form/Form.types.ts";

export type CreateEditV2Props = {
  resource: string;
  layoutForm?: boolean;
  tab?: string;
};

export function createEditV2({
  layoutForm,
  resource,
  tab,
  ...restProps
}: CreateEditV2Props) {
  const LayoutFormComponent = () => {
    const { layoutConfig } = useResourceFormContext();
    return <ResourceFormLayout config={layoutConfig} />;
  };
  const RegularComponent = () => {
    return (
      <ResourceRoute
        type={FormAction.Edit}
        tab={tab}
        resource={resource}
        {...restProps}
      />
    );
  };
  const Component = layoutForm ? LayoutFormComponent : RegularComponent;
  const loader = async () => {
    if (!layoutForm) {
      await Promise.all([
        queryClient.ensureQueryData(
          resourceFormConfigQuery({
            resource: resource,
            action: FormAction.Edit,
          }),
        ),
        queryClient.ensureQueryData(
          formTranslationsQuery({
            resource,
            action: FormAction.Edit,
          }),
        ),
      ]);
    }

    return null;
  };
  const ErrorBoundary = RouteErrorBoundary;
  return {
    Component,
    loader,
    ErrorBoundary,
  };
}
